
import { Component, Prop } from 'vue-property-decorator';
import BasicControl from '@/ui/components/devices/devices/BasicControl';
import FeedbackProvider from '@/ui/components/devices/components/FeedbackProvider.vue';

/**
 * Component that represent Plus Basic Control
 */
@Component({
  components: { FeedbackProvider },
})
export default class PlusBase extends BasicControl {
  @Prop() variableData!: any;
  @Prop() instance!: string;
  @Prop({ default: false }) isPushButtonBehavior!: boolean;
  @Prop({ default: 'green' }) color!: string;
  @Prop({ default: false }) fab!: boolean;
  @Prop({ default: 'plus' }) icon!: string;
  @Prop({
    default: 'small',
    validator: (value: any): boolean => [null, 'x-small', 'small', 'large', 'x-large'].some((el: string | null) => el === value),
  }) buttonSizeClass!: string; // vuetify btn classes: x-small, small, large, x-large

  /**
   * Used to disable the Base component if there is no variable set in the mappings of the device.
   */
  get isNotMapped() {
    return this.mappingsClean.commandPlus === '';
  }

  handlePlus() {
    this.send([{ v: 1, n: this.mappingsClean.commandPlus, u: '' }]);
    this.send([{ v: 0, n: this.mappingsClean.commandPlus, u: '' }]);
  }

  down() {
    this.send([{ v: 1, n: this.mappingsClean.commandPlus, u: '' }]);
  }
  up() {
    this.send([{ v: 0, n: this.mappingsClean.commandPlus, u: '' }]);
  }

  onStateChange(fn: any) {
    this.onSendStart();
    fn();
    this.onSendSuccess();
  }
}
